import { NewsSentimentEnum } from "~/feature/chart/types";

export const labelByNewsSentiment: Record<NewsSentimentEnum, string> = {
  [NewsSentimentEnum.POSITIVE]: "Positive",
  [NewsSentimentEnum.NEGATIVE]: "Negative",
  [NewsSentimentEnum.NEUTRAL]: "Neutral",
};

export const newsMarkerHint = "Hover marker for details";
